import AdvertiserDomain, { IAdvertiserDomainAPI } from './AdvertiserDomain';

export interface IUniqueAdvertiserAPI {
  advertiser_domains: IAdvertiserDomainAPI[];
  logo_url: string;
  name: string;
  replacement_id: number;
  replacement_unique_advertiser: IUniqueAdvertiserAPI;
  uniqueadvertiser_id: number;
}

export interface IUniqueAdvertiser {
  id: number;

  name: string;

  logoUrl?: string;

  advertiserDomains?: AdvertiserDomain[];

  replacementUniqueAdvertisers?: IUniqueAdvertiser;

  replacementID?: number;
}

export default class UniqueAdvertiser implements IUniqueAdvertiser {
  id: number;

  name: string;

  logoUrl?: string;

  advertiserDomains?: AdvertiserDomain[];

  replacementUniqueAdvertisers?: UniqueAdvertiser;

  replacementID?: number;

  constructor(
    id = -1,
    name: string,
    logoUrl?: string,
    advertiserDomains?: AdvertiserDomain[],
    replacementUniqueAdvertisers?: UniqueAdvertiser,
    replacementID?: number,
  ) {
    this.id = id;
    this.name = name;
    this.logoUrl = logoUrl;
    this.advertiserDomains = advertiserDomains;
    this.replacementUniqueAdvertisers = replacementUniqueAdvertisers;
    this.replacementID = replacementID;
  }

  static fromApi(apiObject: IUniqueAdvertiserAPI): UniqueAdvertiser {
    return new UniqueAdvertiser(
      apiObject.uniqueadvertiser_id,
      apiObject.name,
      apiObject.logo_url,
      apiObject.advertiser_domains ? apiObject.advertiser_domains.map((x) => AdvertiserDomain.fromApi(x)) : [],
      apiObject.replacement_unique_advertiser
        ? UniqueAdvertiser.fromApi(apiObject.replacement_unique_advertiser)
        : null,
      apiObject.replacement_id,
    );
  }

  matchesSearchTerm(term: string): boolean {
    return (
      this.name.toLowerCase().includes(term.toLowerCase()) ||
      this.advertiserDomains.some((ad) => ad.domain.toLowerCase().includes(term.toLowerCase()))
    );
  }

  toApi(): IUniqueAdvertiserAPI {
    return {
      uniqueadvertiser_id: this.id >= 0 ? this.id : undefined,
      name: this.name,
      logo_url: this.logoUrl,
      advertiser_domains: this.advertiserDomains != null ? this.advertiserDomains.map((x) => x.toApi()) : undefined,
      replacement_unique_advertiser:
        this.replacementUniqueAdvertisers != null ? this.replacementUniqueAdvertisers.toApi() : undefined,
      replacement_id: this.replacementID,
    };
  }
}
